// extracted by mini-css-extract-plugin
export default {"h1":"WelcomeMessage_h1__u3rIh","p":"WelcomeMessage_p__L7V3b","button":"WelcomeMessage_button__iqAa8"};